import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SET_RESPONSE_STATUS } from '../../services/cms-page-data.service';
import { CompassHexComponent } from '../shared/compass-hex/compass-hex.component';

@Component({
  selector: 'app-error404',
  standalone: true,
  imports: [RouterLink, CompassHexComponent],
  templateUrl: './error404.component.html',
  styleUrl: './error404.component.scss',
})
export class Error404Component {
  private setStatus = inject(SET_RESPONSE_STATUS, { optional: true });

  constructor() {
    this.setStatus?.(404);
  }
}
